import { BaseFieldFilter, NativeFieldFilter } from 'api/dashboard/widget';
import {
  AssigneeField,
  AssigneeValue,
} from 'components/organisms/tasks/fields';
import { AssigneeFieldFilter } from 'components/organisms/tasks/filters/assignee';
import {
  SelectFilterOperationType,
  valueFromString,
  valueToString,
} from 'components/organisms/tasks/filters/select';
import { unreachable } from 'utils/unreachable';
import { Operation } from '../operations';
import { toType } from './select'; // Right now backend does not support user-{id}/team-{id} format,

// Right now backend does not support user-{id}/team-{id} format,
// so we are sending only id to backend and backend consider this as user id. We will revert this back to its original state once BE fixes
const to = valueToString<AssigneeValue>((x) => x.join('-'));
const from = valueFromString((x) => x.split('-') as AssigneeValue);

const toApiFormat = (filter: AssigneeFieldFilter): BaseFieldFilter => {
  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return {
        operation: Operation.IsEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNotEmpty:
      return {
        operation: Operation.IsNotEmpty,
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.Is:
      return {
        operation: Operation.Value,
        value: to(filter.value ?? []),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNot:
      return {
        operation: Operation.IsNot,
        value: to(filter.value ?? []),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsNoneOf:
      return {
        operation: Operation.NoneOf,
        value: to(filter.value ?? []),
        sourceType: filter.field.sourceType,
      };
    case SelectFilterOperationType.IsOneOf:
      return {
        operation: Operation.OneOf,
        value: to(filter.value ?? []),
        sourceType: filter.field.sourceType,
      };
    default:
      return unreachable(filter);
  }
};

const parse = (
  { value, operation }: NativeFieldFilter,
  field: AssigneeField,
): AssigneeFieldFilter => {
  const type = toType(operation);

  switch (type) {
    case SelectFilterOperationType.IsEmpty:
    case SelectFilterOperationType.IsNotEmpty:
      return { field, type };
    case SelectFilterOperationType.Is:
    case SelectFilterOperationType.IsNot:
    case SelectFilterOperationType.IsOneOf:
    case SelectFilterOperationType.IsNoneOf:
      return { field, type, value: from(value ?? '') };
    default:
      return unreachable(type);
  }
};

export const AssigneeFilter = {
  parse,
  toApiFormat,
};
